// 3D 체력바 클래스
class HealthBar {
  constructor(scene, target) {
    this.scene = scene;
    this.target = target; // 체력바를 따라갈 대상 (플레이어 등)
    this.healthBarGroup = null;
    this.backgroundBar = null;
    this.healthBar = null;
    this.maxHealth = 100;
    this.currentHealth = 100;
    this.offset = { x: 0, y: 3, z: 0 }; // 대상으로부터의 오프셋 (머리 위)

    this.init();
  }

  // 체력바 초기화
  init() {
    // 체력바 그룹 생성
    this.healthBarGroup = new THREE.Group();

    // 체력바 크기 설정
    const barWidth = 2.0;
    const barHeight = 0.2;
    const barDepth = 0.05;

    // 배경 바 (회색) 생성
    const backgroundGeometry = new THREE.BoxGeometry(
      barWidth,
      barHeight,
      barDepth
    );
    const backgroundMaterial = new THREE.MeshBasicMaterial({
      color: 0x333333,
      transparent: true,
      opacity: 0.8,
    });
    this.backgroundBar = new THREE.Mesh(backgroundGeometry, backgroundMaterial);
    this.healthBarGroup.add(this.backgroundBar);

    // 체력 바 (빨간색에서 초록색) 생성
    const healthGeometry = new THREE.BoxGeometry(
      barWidth,
      barHeight,
      barDepth + 0.01
    );
    const healthMaterial = new THREE.MeshBasicMaterial({
      color: 0x00ff00,
      transparent: true,
      opacity: 0.9,
    });
    this.healthBar = new THREE.Mesh(healthGeometry, healthMaterial);
    this.healthBarGroup.add(this.healthBar);

    // 체력바가 항상 카메라를 향하도록 설정 (빌보드)
    this.healthBarGroup.userData.isBillboard = true;

    // 씬에 추가
    this.scene.add(this.healthBarGroup);
  }

  // 체력 업데이트
  updateHealth(currentHealth, maxHealth = null) {
    if (maxHealth !== null) {
      this.maxHealth = maxHealth;
    }
    this.currentHealth = Math.max(0, Math.min(currentHealth, this.maxHealth));

    // 체력 비율 계산
    const healthRatio = this.currentHealth / this.maxHealth;

    // 풀피일 때는 체력바 숨기기
    if (healthRatio >= 1.0) {
      this.setVisible(false);
      return;
    }

    // 체력바 표시
    this.setVisible(true);

    // 체력바 크기 조정
    this.healthBar.scale.x = healthRatio;

    // 체력바 위치 조정 (왼쪽 정렬)
    const barWidth = 2.0;
    this.healthBar.position.x = (-barWidth * (1 - healthRatio)) / 2;

    // 체력에 따른 색상 변경
    const color = this.getHealthColor(healthRatio);
    this.healthBar.material.color.setHex(color);
  }

  // 체력 비율에 따른 색상 계산
  getHealthColor(healthRatio) {
    if (healthRatio > 0.6) {
      // 초록색 (건강)
      return 0x00ff00;
    } else if (healthRatio > 0.3) {
      // 노란색 (주의)
      return 0xffff00;
    } else {
      // 빨간색 (위험)
      return 0xff0000;
    }
  }

  // 체력바 위치 업데이트 (매 프레임 호출)
  update(camera) {
    if (!this.target || !this.target.model || !this.healthBarGroup) return;

    // 대상의 위치 가져오기
    const targetPosition = this.target.getPosition();

    // 체력바 위치 설정 (대상 위 + 오프셋)
    this.healthBarGroup.position.set(
      targetPosition.x + this.offset.x,
      targetPosition.y + this.offset.y,
      targetPosition.z + this.offset.z
    );

    // 빌보드 효과 (항상 카메라를 향함)
    // 카메라의 회전을 직접 복사하여 항상 정면을 바라보도록 함
    if (camera) {
      this.healthBarGroup.quaternion.copy(camera.quaternion);
    }
  }

  // 체력바 표시/숨김
  setVisible(visible) {
    if (this.healthBarGroup) {
      this.healthBarGroup.visible = visible;
    }
  }

  // 체력바 제거
  destroy() {
    if (this.healthBarGroup) {
      this.scene.remove(this.healthBarGroup);
      this.healthBarGroup = null;
      this.backgroundBar = null;
      this.healthBar = null;
    }
  }

  // 오프셋 설정
  setOffset(x, y, z) {
    this.offset = { x, y, z };
  }
}

// webpack 빌드를 위해 default export 추가
export default HealthBar;

// 전역 변수로도 등록 (기존 코드 호환성)
window.HealthBar = HealthBar;
